var map = {
	"./photo1.png": 195,
	"./photo11.png": 874,
	"./photo12.png": 41,
	"./photo13.png": 176,
	"./photo14.png": 343,
	"./photo15.png": 30,
	"./photo16.png": 381,
	"./photo17.png": 284,
	"./photo18.png": 443,
	"./photo19.png": 226,
	"./photo2.png": 376,
	"./photo20.png": 821,
	"./photo21.png": 747,
	"./photo22.png": 184,
	"./photo3.png": 625,
	"./photo4.png": 206,
	"./photo6.png": 903,
	"./photo7.png": 413,
	"./photo8.png": 642,
	"./photo9.png": 555
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 287;